import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from '../../../hooks';
import { selectHastaReceiver } from '../../../reducers/hastaReceiversSlice';
export const ConfigHastaReceiverRow = (props) => {
    const receiver = useAppSelector(selectHastaReceiver(props.id));
    if (!receiver) {
        return null;
    }
    const active = true;
    const label_classes = 'inactive label ' + (active ? ' hidden' : '');
    return (_jsxs("div", { className: "config-receiver-row", children: [_jsxs("div", { children: [receiver.title, _jsx("span", { className: label_classes, children: "Inaktiv" })] }), _jsx("div", {}), _jsx("div", { className: "pull-right", children: _jsx("button", { className: "edit lw small", onClick: () => props.editHandler(receiver.id), children: "\u00A0Redigera\u00A0" }) })] }));
};
